/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import L from "../Lang"
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import Icon from "../Icon";
import { SidebarGlobal } from "../_SidebarGlobal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { Modal } from "react-bootstrap";
import { Pop } from "../PopModal";
import { qreq } from "../../shared/qrequest";
import Auth from "../../shared/Auth";
import Globals from "../../shared/Globals";
import React from "react";

class WorkflowList extends BaseCom {

    async componentDidMount() {
        this.updateSidebar();
        await this.load();
        this.fileRef = React.createRef();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.showDisabled !== prevState.showDisabled)
            this.updateSidebar();
    }

    updateSidebar = () => {
        SidebarGlobal.setSubNav(<>
            <button className="btn btn-primary" onClick={() => this.props.navigate('/workflow/new')}>
                <Icon icon="faPlus" />
                <span className="d-none d-md-inline"><L>New</L></span>
            </button>
            <button className="btn btn-secondary" onClick={this.import}>
                <Icon icon="faFileImport" />
                <span className="d-none d-md-inline"><L>Import</L></span>
            </button>
            <button className="btn btn-secondary" onClick={() => this.toggleDisabled()}>
                <Icon icon={this.state.showDisabled ? 'faEyeSlash' : 'faEye'} />
                <span className="d-none d-md-inline"> {this.state.showDisabled ? 'Hide' : 'Show'} Disabled</span>
            </button>
        </>);
    }

    load = async (showDisabled) => {
        if (showDisabled === undefined) showDisabled = this.state.showDisabled;
        await this.fillListAsync('/api/workflow/list?showDisabled=' + (showDisabled ? 'true' : 'false'), 'list');
    }

    toggleDisabled = async () => {
        let showDisabled = !this.state.showDisabled;
        await this.load(showDisabled);
        this.setState({ showDisabled: showDisabled });
    }

    delete = (item) => {
        Pop.showConfirm(<><L>Are you sure you want to delete</L><strong>{item.name}</strong><L>?</L></>, 'Delete Workflow', async () => {
            try {
                let j = await qreq.postAsync('/api/workflow/delete', { id: item.id });
                if (j.errorCode === 0) {
                    this.success('Deleted!');
                    this.setState({ selected: null });
                    await this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e)
            }
        });
    }

    restore = (item) => {
        Pop.showConfirm(<><L>Are you sure you want to restore</L><strong>{item.name}</strong><L>?</L></>, 'Restore Workflow', async () => {
            try {
                let j = await qreq.postAsync('/api/workflow/restore', { id: item.id });
                if (j.errorCode === 0) {
                    this.success('Restored!');
                    this.setState({ selected: null });
                    await this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e)
            }
        });
    }

    export = (item) => {
        window.open(Globals.serverUrl + '/api/workflow/export/' + item.id + '/json');
    }

    import = () => {
        this.fileRef.current.click();
    }

    _import = (event) => {
        const reader = new FileReader();

        reader.onload = async (e) => {
            try {
                let j = await qreq.postAsync('/api/workflow/import/json', { data: e.target.result });
                if (j.errorCode === 0) {
                    this.success('Import success!');
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        };

        reader.onerror = function (e) {

        };

        reader.readAsText(event.target.files[0]);

        this.fileRef.current.value = '';
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>Workflows</L></h1>

                <input type="file" ref={this.fileRef} style={{ display: 'none' }} onChange={this._import} />

                {this.state.selected && <Modal show={this.state.selected} onHide={() => this.setState({ selected: null })}>
                    <Modal.Header>
                        {this.state.selected.name}
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-grid gap-1">
                            {Auth.hasRole('admin') && <button type="button" className="btn btn-primary" onClick={() => this.export(this.state.selected)}>
                                <Icon icon="faDownload" /> <L>Export</L></button>}
                            {this.state.selected.isDisabled ? <button type="button" className="btn btn-primary" onClick={() => this.restore(this.state.selected)}>
                                <Icon icon="faTrashArrowUp" /> <L>Restore</L></button>
                                : <button type="button" className="btn btn-danger" onClick={() => this.delete(this.state.selected)}>
                                    <Icon icon="faTrash" /> <L>Delete</L></button>}
                            <button type="button" className="btn btn-secondary" onClick={() => this.setState({ selected: null })}>
                                <Icon icon="faCancel" /> <L>Close</L></button>
                        </div>
                    </Modal.Body>
                </Modal>}

                <DataTable
                    model="workflow"
                    columns={[
                        {
                            name: 'actions',
                            valueFunc: row => (<>
                                <Link to={`./${row.id}`} className="btn btn-primary">
                                    <Icon icon="faEye" />
                                </Link>
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ selected: row })}>
                                    &nbsp;<Icon icon="faEllipsisV" /> <L>&nbsp;</L></button>
                            </>
                            ),
                            style: { maxWidth: '200px' }
                        },
                        {
                            name: 'name', title: 'Name', valueFunc: (row) =>
                                <Link to={`./${row.id}`}>{row.name}</Link>
                        },
                        { name: 'description', title: 'Description' },
                        {
                            name: 'isDisabled', title: 'Status',
                            valueFunc: (row) => row.isDisabled ? <><L>Disabled</L></> : <><L>Active</L></>
                        }
                    ]}
                    data={this.state.list || []}

                />
            </div>
        );
    }
}

export default withParamsAndNavigate(WorkflowList);